import axios, { AxiosHeaders } from "axios";
import { getAuthHeaders, getNonAuthHeaders } from "../config/auth";
import { sha256 } from "../lib/mainData";

const url: any = process.env.REACT_APP_URL_API;
const { REACT_APP_SECRET_KEY } = process.env;

export const Httpcommon = axios.create({
  baseURL: url,
  headers: {
    "Content-type": "application/json",
  },
});

Httpcommon.interceptors.request.use(
  async (config) => {
    const payload =
      config.method === "get"
        ? !!config.params
          ? Object.values(config.params).join("").replace(/\s+/g, "+")
          : ""
        : !!config.data
        ? JSON.stringify(config.data)
        : "";

    const headers = await getAuthHeaders(payload);
    const axiosHeaders = new AxiosHeaders(headers);

    return { ...config, headers: axiosHeaders };
  },
  (error) => Promise.reject(error)
);

export const HttpcommonToken = axios.create({
  baseURL: url,
  headers: {
    "Content-type": "application/json",
  },
});

HttpcommonToken.interceptors.request.use(
  (config) => {
    config.headers.signature = sha256(
      JSON.stringify(config.data) + REACT_APP_SECRET_KEY
    );

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const HttpcommonNonAuth = axios.create({
  baseURL: url,
  headers: {
    "Content-type": "application/json",
  },
});

HttpcommonNonAuth.interceptors.request.use(
  async (config) => {
    config.headers.signature = sha256(
      JSON.stringify(config.data) + REACT_APP_SECRET_KEY
    );

    const payload =
      config.method === "get"
        ? !!config.params
          ? Object.values(config.params).join("").replace(/\s+/g, "+")
          : ""
        : !!config.data
        ? JSON.stringify(config.data)
        : "";

    const headers = await getNonAuthHeaders(payload);
    const axiosHeaders = new AxiosHeaders(headers);

    return { ...config, headers: axiosHeaders };
  },
  (error) => {
    return Promise.reject(error);
  }
);
